import { useEffect, useRef } from "react";

export default function TranscriptPanel({ lines }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [lines]);

  return (
    <section
      data-testid="transcript-panel"
      className="xl:col-span-5 flex flex-col h-full bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden"
    >
      <div className="px-5 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="font-display text-sm font-semibold tracking-wider text-slate-500 uppercase">
          Live Transcript
        </div>
        <div className="text-xs text-slate-400 font-mono">{lines.length} lines</div>
      </div>

      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto sch-scroll px-5 py-4 space-y-3"
        data-testid="transcript-scroll"
      >
        {lines.length === 0 && (
          <div className="text-sm text-slate-400 italic text-center mt-12 max-w-sm mx-auto leading-relaxed">
            Press <span className="font-mono text-slate-600">Start Listening</span> and share the
            meeting tab with audio. Transcript will appear here in real time.
          </div>
        )}
        {lines.map((l, i) => (
          <TranscriptBubble key={i} line={l} />
        ))}
      </div>
    </section>
  );
}

function TranscriptBubble({ line }) {
  const isProspect = line.speaker === "prospect";
  return (
    <div
      data-testid={`transcript-line-${line.speaker}`}
      className={`sch-fade-in flex ${isProspect ? "justify-start" : "justify-end"}`}
    >
      <div className={isProspect ? "max-w-[85%] mr-8" : "max-w-[85%] ml-8"}>
        <div
          className={`text-[10px] uppercase tracking-widest mb-1 ${
            isProspect ? "text-blue-700" : "text-slate-500"
          }`}
        >
          {isProspect ? "Prospect" : "Closer"}
        </div>
        <div
          className={`rounded-xl px-3.5 py-2.5 text-sm leading-relaxed ${
            isProspect
              ? "bg-blue-50 border border-blue-100 text-blue-900 rounded-bl-sm"
              : "bg-slate-50 border border-slate-100 text-slate-800 rounded-br-sm"
          }`}
        >
          {line.text}
        </div>
      </div>
    </div>
  );
}
